"use client"
import {
    Badge,
    Box,
    Button,
    Card,
    CardBody,
    CardFooter,
    Collapse,
    Flex,
    Heading,
    HStack,
    LinkBox,
    Text,
    VStack
} from "@chakra-ui/react";
import moment from "moment/moment";
import {getDealOwnerDescription, IMomentDeal, isBar, isChain, NearbyDeal} from "../../interfaces/IMomentDeal";
import {useTranslations} from "next-intl";
import {Moment} from "moment";
import styles from "./layout.module.css";
import {LinkOverlayToDealOwner} from "./LinkOverlayToDealOwner";
import {LastUpdated} from "../LastUpdated";
import {ContributeMenu} from "./widget/ContributeMenu";
import {useEffect, useState} from "react";
import {Bar, GeoLocation} from "../../interfaces/Bar";
import {minBy} from "lodash";
import DistanceView from "./widget/DistanceView";
import {MdLocalFireDepartment, MdMyLocation} from "react-icons/md";
import {getDistance, useGeolocation} from "../tools/useGeolocation";

function format(data: Moment, isAfterMidnight: boolean): string {
    const reference = moment().add(1, 'day').startOf('day')
    return isAfterMidnight ? data.calendar(reference) : data.calendar()
}

function DealTitle({deal}: {deal: IMomentDeal}) {
    let tHome = useTranslations("Home")
    return (
        <HStack justify="space-between" w="100%">
            <LinkOverlayToDealOwner owner={deal.owner}>
                <Heading size="md">
                    {/*{deal.description}*/}
                    {tHome("various_offers")}
                </Heading>
            </LinkOverlayToDealOwner>
            <ContributeMenu dealOwner={deal.owner}/>
        </HStack>
    )
}

function withProximity(happeningNow: IMomentDeal[], location: GeoLocation, sort: boolean): NearbyDeal[] {
    const result = happeningNow
        .flatMap((deal) => {
            let bars: Bar[] = []
            if (isBar(deal.owner)) bars = [deal.owner]
            else if (isChain(deal.owner)) bars = deal.owner["bars"]

            const bestLocation = minBy(bars.map(bar => {
                return {
                    distance: bar.location ? getDistance(
                        location.lat,
                        location.lng,
                        bar.location.lat,
                        bar.location.lng
                    ) : Infinity,
                    bar: bar
                }
            }), "distance")
            if (bestLocation) {
                return [{
                    ...deal,
                    ...bestLocation
                }]
            } else {
                return []
            }
        })

    return sort ?
        result.sort((a, b) => a.distance - b.distance) : result
}

function AdView() {
    const {location, watching} = useGeolocation()
    useEffect(() => {
        const load = () => {
            console.log("Loading ad")
            try {
                (window as any).adsbygoogle = (window as any).adsbygoogle || [];
                (window as any).adsbygoogle.push({});
            } catch (e) {
                console.error('Error loading ads:', e);
            }
        }
        if (watching == false || location !== undefined) {
            setTimeout(load, 1000)
        }
    }, [watching, location]);
    console.log("Location", location, "Watching", watching);
    return (
        <>
            <ins className="adsbygoogle"
                 style={{display: "block", minWidth: "400px", maxWidth: "100%", width: "100%", height: "100%", flexGrow: 1}}
                 data-ad-format="fluid"
                 data-ad-layout-key="-gf-1r+f-bi+nr"
                 data-ad-client="ca-pub-9582560298290921"
                 data-ad-slot="4774964279"></ins>
        </>
    )
}

export default function HappeningNowView(
    {happeningNow, upcoming, wrap = true, marginX = "20px"}: {
        happeningNow: IMomentDeal[],
        upcoming: IMomentDeal[],
        wrap?: boolean,
        marginX?: string
    }
) {
    const t = useTranslations("Home")
    const [nearbyDeals, setNearbyDeals] = useState<NearbyDeal[] | undefined>()
    const {location, startWatching, stopWatching, watching} = useGeolocation()

    useEffect(() => {
        if (location) {
            setNearbyDeals(withProximity(happeningNow, location, true))
            setNearbyUpcoming(withProximity(upcoming, location, false))
        }
    }, [happeningNow, upcoming, location]);

    const [nearbyUpcoming, setNearbyUpcoming] = useState<NearbyDeal[]|undefined>()
    useEffect(() => {
        console.log("Nearby upcoming", nearbyUpcoming)
    }, [nearbyUpcoming]);


    return (
        <Flex direction="column" data-nosnippet minH={0} w="100%" h="100%" justify="center">
            {watching == false && !wrap && (
                <Button ml={8} variant="secondary" leftIcon={<MdMyLocation/>} isLoading={watching && location === undefined} w="min-content" onClick={startWatching}>
                    {t("find_nearby")}
                </Button>
            )}
            <Flex direction="row" flexWrap={wrap ? "wrap" : "nowrap"} overflowX="auto" gap={4} flexShrink={1} overflowY="hidden" p={2} className={styles.scrollerpager}>
                {(nearbyDeals ?? happeningNow).map((now) => (
                    // Happening now
                    <MomentDealView deal={now} wrap={wrap} marginX={marginX} key={now.day + now.description + now.owner.name}/>
                ))}
                {
                    (happeningNow.length == 0) && (nearbyUpcoming ?? upcoming).flatMap((deal, idx) => {
                        // Upcoming
                        const previousToday = upcoming[idx - 1]?.today == true
                        const previousTomorrow = upcoming[idx - 1]?.tomorrow == true
                        const today = deal.today && !previousToday;
                        const tomorrow = deal.tomorrow && !previousTomorrow;
                        const later = !deal.tomorrow && !deal.today && (previousToday || previousTomorrow || idx == 0);

                        const whenLabel = today ? t("today") : tomorrow ? t("tomorrow") : later ? t("later") : ""
                        return [
                            <>
                            {wrap && (tomorrow || today || later) && (
                                    <Heading w="100%" size="md" key={whenLabel}>
                                        {whenLabel}
                                    </Heading>
                            )}
                            </>,
                            [
                                <>
                                    {/*{ idx % 10 == 3 && <Flex key={`ad-${idx}`} maxW="100%" maxH="600px" flexGrow={1} borderColor="red" borderWidth={process.env.NODE_ENV === 'development' ? "1px" : "0px"}>
                                        <AdView/>
                                    </Flex>}*/}
                                </>,
                                <MomentDealView
                                    deal={deal}
                                    marginX={marginX}
                                    wrap={wrap}
                                    key={deal.description + deal.owner.name + deal.times[1].toISOString() + deal.times[0].toISOString()}/>
                            ]
                        ]
                    })
                }
            </Flex>
        </Flex>
    )
}

function HappeningNowBadge() {
    const t = useTranslations("Home")
    return (
        <Badge p="5px" key="now" colorScheme="red">
            <HStack align="center">
                <MdLocalFireDepartment/>
                <Text mb={0}>{t("happeningNow")}</Text>
            </HStack>
        </Badge>
    )
}

function MomentDealView({deal, marginX, wrap=false} : {deal: IMomentDeal, marginX?: string, wrap?: boolean}) {
    const t = useTranslations("Home")
    const minCardWidth = "200px"
    const isNow = moment() > deal.times[0] && moment() < deal.times[1]
    return (
        <Box
            /*key={deal.description + deal.owner.name + deal.times[1].toISOString() + deal.times[0].toISOString()}*/
            ml={marginX}
            className={styles.snappage}
            minH={0}
            flexShrink={wrap ? 1 : 0}
            flexGrow={1}
            maxW={wrap ? "100%" : {base: "90vw", md: "40vw"}}
            minW={minCardWidth}>
            <LinkBox h="100%">
                <Card variant="elevated" size="sm" borderRadius="20px" minH="0" h="100%">
                    <CardBody>
                        <Flex w="100%" align="start" direction="column" gap={1} h="100%" justify="space-between">
                            <DealTitle deal={deal}/>
                            {/*{deal.conditions && <Conditions conditions={deal.conditions}/>}*/}
                            <VStack flexGrow={1} gap={0} align="start">
                                <Text mb={0} color="teal">{deal.owner.name}</Text>
                                {getDealOwnerDescription(deal.owner) && <Text as="i">{getDealOwnerDescription(deal.owner)}</Text>}
                            </VStack>
                            <VStack align="end" w="100%" mt={3}>
                                <Text
                                    as="b">{format(deal.times[0], deal.afterMidnight.start)}{deal.afterMidnight.start &&
                                    <sup>+1</sup>} - {deal.times[1].format("LT")}{deal.afterMidnight.end &&
                                    <sup>+1</sup>}</Text>
                                {isNow ? [
                                    <HappeningNowBadge key="now"/>,
                                    <Badge p="5px" key="ends" colorScheme={moment().add(30, 'minutes') > deal.times[1] ? 'orange' : 'green'}>
                                        {t("endsAt", {
                                            when: `${deal.times[1].fromNow()} (${deal.times[1].format("LT")})`
                                        })}
                                    </Badge>
                                ] : (
                                    <Badge colorScheme={moment().add(3, 'hours') > deal.times[0] ? 'green' : 'gray'}
                                           fontSize="xs">{t("starts")} {deal.times[0].fromNow()}</Badge>
                                )}
                            </VStack>
                        </Flex>
                    </CardBody>
                    <CardFooter>
                        <VStack direction="column" align="end" w="100%">
                            <Collapse in={deal["distance"] && deal["distance"] != Infinity}>
                                <DistanceView distance={deal["distance"]} bar={deal["bar"]}/>
                            </Collapse>
                            {deal.owner.updated_at && <LastUpdated updatedAt={deal.owner.updated_at}/>}
                        </VStack>
                    </CardFooter>
                </Card>
            </LinkBox>
        </Box>
    )
}